import { EN, VI, initI18n } from "@garther/ui/libs";

import { AppCfg } from "@/shared/config/app";

// Import translation files
import en from "./locales/en.json";
import vi from "./locales/vi.json";

// Initialize i18n with app-specific translations
initI18n({
  resources: {
    en: {
      ...EN,
      ...en
    },
    vi: {
      ...VI,
      ...vi
    }
  },
  defaultLanguage: "vi",
  fallbackLanguage: "vi",
  debug: !AppCfg.isProd
});
